export default __webpack_public_path__ + "static/media/favourite.53228ea7.svg";